import { useQuery } from "@apollo/client";
import { Center, Spinner, useToast } from "@chakra-ui/react";
import { useEffect, useState } from "react";
import { useMercadopago } from "react-sdk-mercadopago/lib";
import { GET_PREFERENCE } from "../../services/graphql/query/MercadoPago";
import useScript from "../../services/hooks/useScripts";
import { MessageError } from "../../shared/MessageError";

const FORM_ID = "payment-form";
interface IMercadoPagoProps {
  onLoaded: () => void;
  onError: () => void;
}
export const MercadoPago = (props: IMercadoPagoProps) => {
  const { onLoaded, onError } = props;
  const [loading, setLoading] = useState(false);
  const [loadingPreference, setLoadingPreference] = useState(true);
  const [preferenceId, setPreferenceId] = useState<string>("");
  const toast = useToast();
  const stateScript = useScript("https://sdk.mercadopago.com/js/v2");
  useQuery(GET_PREFERENCE, {
    onCompleted: (dataGetPreference) => {
      const { getPreference } = dataGetPreference;
      setPreferenceId(getPreference.id);
      setLoadingPreference(false);
    },
    onError: (error) => {
      toast({
        duration: 2500,
        position: "top",
        render: () =>
          MessageError(
            error.message ? error.message : "Hubo un error con Mercado Pago"
          ),
      });
      setLoadingPreference(false);
    },
  });
  const addCheckout = () => {
    const mp = new window.MercadoPago(
      process.env.REACT_APP_PUBLIC_KEY_MP ||
        "TEST-64f6fed6-a575-444d-9483-2d412dee3f9f",
      {
        locale: "es-AR",
      }
    );

    // Inicializa el checkout
    mp.checkout({
      preference: {
        id: preferenceId,
      },
      autoOpen: true,
    });
  };
  useEffect(() => {
    if (stateScript.value === "loading") {
      setLoading(true);
    } else {
      setLoading(false);
    }
    if (stateScript.value === "error") {
      setLoading(false);
      onError();
      throw stateScript.payload;
    }
    if (stateScript.value === "loaded") {
      onLoaded();
      setLoading(false);
      if (preferenceId) {
        addCheckout();
      }
    }
  }, [stateScript.value, preferenceId]);

  return (
    <div>
      <div className={FORM_ID} />
    </div>
  );
};
